import { useEffect } from "react";
import { useRefCache } from "@react-md/utils";
/**
 * This hook will call the `onShow` and `onHide` functions as needed based on
 * the current interaction mode and the visibility of the tooltip.
 *
 * @internal
 */
export function useVisiblityChange(_a) {
    var onShow = _a.onShow, onHide = _a.onHide, visible = _a.visible, mode = _a.mode;
    var handlers = useRefCache({ onShow: onShow, onHide: onHide });
    useEffect(function () {
        if (!visible || mode === null) {
            return;
        }
        var _a = handlers.current, onShow = _a.onShow, onHide = _a.onHide;
        if (onShow) {
            onShow(mode);
        }
        return function () {
            if (onHide) {
                onHide();
            }
        };
        // only want to trigger on visibility changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible]);
}
//# sourceMappingURL=useVisibilityChange.js.map